import { Route, Routes } from '@angular/router';
import { DEMO_PAGES } from './demo-pages';

export const EXCELLENCE_UI_DEMO_PAGES: (Route & { data: { title: string } })[] = DEMO_PAGES.map(
  (page) => ({
    ...page,
    loadComponent: () => {
      switch (page.path) {
        case 'alert':
          return import('./pages/alert-page/alert-page').then((m) => m.AlertPage);
        case 'badge':
          return import('./pages/badge-page/badge-page').then((m) => m.BadgePage);
        case 'button':
          return import('./pages/button-page/button-page').then((m) => m.ButtonPage);
        case 'breadcrumb-nav':
          return import('./pages/breadcrumb-nav-page/breadcrumb-nav-page').then(
            (m) => m.BreadcrumbNavPage,
          );
        case 'calendar-input':
          return import('./pages/calendar-input-page/calendar-input-page').then(
            (m) => m.CalendarInputPage,
          );
        case 'calendar-range-input':
          return import('./pages/calendar-range-input-page/calendar-range-input-page').then(
            (m) => m.CalendarRangeInputPage,
          );
        case 'chart':
          return import('./pages/chart-page/chart-page').then((m) => m.ChartPage);
        case 'checkbox':
          return import('./pages/checkbox-page/checkbox-page').then((m) => m.CheckboxPage);
        case 'checkbox-group':
          return import('./pages/checkbox-group-page/checkbox-group-page').then(
            (m) => m.CheckboxGroupPage,
          );
        case 'confirm-dialog':
          return import('./pages/confirm-dialog-page/confirm-dialog-page').then(
            (m) => m.ConfirmDialogPage,
          );
        case 'dialog':
          return import('./pages/dialog-page/dialog-page').then((m) => m.DialogPage);
        case 'dropzone':
          return import('./pages/dropzone-page/dropzone-page').then((m) => m.DropzonePage);
        case 'file-input':
          return import('./pages/file-input-page/file-input-page').then((m) => m.FileInputPage);
        case 'help-button':
          return import('./pages/help-button-page/help-button-page').then((m) => m.HelpButtonPage);
        case 'icons':
          return import('./pages/icons-page/icons-page').then((m) => m.IconsPage);
        case 'input-phone':
          return import('./pages/input-phone-page/input-phone-page').then((m) => m.InputPhonePage);
        case 'input':
          return import('./pages/input-page/input-page').then((m) => m.InputPage);
        case 'menu-list':
          return import('./pages/menu-list-page/menu-list-page').then((m) => m.MenuListPage);
        case 'notification':
          return import('./pages/notification-page/notification-page').then(
            (m) => m.NotificationPage,
          );
        case 'popover':
          return import('./pages/popover-page/popover-page').then((m) => m.PopoverPage);
        case 'radio-group':
          return import('./pages/radio-page/radio-page').then((m) => m.RadioPage);
        case 'tab-group':
          return import('./pages/tab-group-page/tab-group-page').then((m) => m.TabGroupPage);
        case 'textarea':
          return import('./pages/textarea-page/textarea-page').then((m) => m.TextareaPage);
        case 'toggle':
          return import('./pages/toggle-page/toggle-page').then((m) => m.TogglePage);
        case 'tooltip':
          return import('./pages/tooltip-page/tooltip-page').then((m) => m.TooltipPage);
        case 'select':
          return import('./pages/select-page/select-page').then((m) => m.SelectPage);
        case 'skeleton':
          return import('./pages/skeleton-page/skeleton-page').then((m) => m.SkeletonPage);
        case 'stepper':
          return import('./pages/stepper-page/stepper-page').then((m) => m.StepperPage);
        case 'switch-bar':
          return import('./pages/switch-bar-page/switch-bar-page').then((m) => m.SwitchBarPage);
        default:
          throw new Error(`Unknown page: ${page.path}`);
      }
    },
  }),
);

export const EXCELLENCE_UI_DEMO_ROUTES: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'components/alert',
  },
  {
    path: 'components',
    loadComponent: () => import('./pages/layout/demo-layout/demo-layout').then((m) => m.DemoLayout),
    children: EXCELLENCE_UI_DEMO_PAGES,
  },
];
